var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#FFA800"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    transform: "translate(19 19) rotate(180)",
    fill: "#FFA800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12.125C7.40482 12.125 7.125 11.8452 7.125 11.5C7.125 11.1548 7.40482 10.875 7.75 10.875L15.25 10.875C15.5952 10.875 15.875 11.1548 15.875 11.5C15.875 11.8452 15.5952 12.125 15.25 12.125L7.75 12.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0581 8.19194C10.814 7.94786 10.814 7.55214 11.0581 7.30806C11.3021 7.06398 11.6979 7.06398 11.9419 7.30806L15.6919 11.0581C15.9286 11.2947 15.9368 11.6757 15.7107 11.9223L12.2732 15.6723C12.04 15.9268 11.6446 15.944 11.3902 15.7107C11.1357 15.4775 11.1185 15.0821 11.3518 14.8277L14.3849 11.5188L11.0581 8.19194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7063d83f1f4f102dda1a7b2e28fd276c.svg";
export { ForwardRef as ReactComponent };